import { render, staticRenderFns } from "./r-no-data.vue?vue&type=template&id=0a2ac534"
var script = {}
import style0 from "./r-no-data.vue?vue&type=style&index=0&id=0a2ac534&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports